// extracted by mini-css-extract-plugin
export default {"products":"zu-z","card":"Au-z","oosMessaging":"Bu-z"};